// src/hooks/useApiMutation.js
import { useMutation } from "@tanstack/react-query";

/**
 * Обертка над useMutation, которая автоматически генерирует
 * Idempotency-Key для предотвращения дублей при Retry.
 */
export function useApiMutation(options) {
  const mutation = useMutation(options);

  const mutateWithIdempotency = (variables, mutateOptions) => {
    const idempotencyKey = crypto.randomUUID();
    return mutation.mutate(
      { ...variables, __idempotencyKey: idempotencyKey },
      mutateOptions,
    );
  };

  const mutateAsyncWithIdempotency = (variables, mutateOptions) => {
    const idempotencyKey = crypto.randomUUID();
    return mutation.mutateAsync(
      { ...variables, __idempotencyKey: idempotencyKey },
      mutateOptions,
    );
  };

  return {
    ...mutation,
    mutate: mutateWithIdempotency,
    mutateAsync: mutateAsyncWithIdempotency,
  };
}
